import { postApi } from "./Api";

export const login = async (email:string, password:string) => {
    try{
        return await postApi<{access_token:string}>('auth/login', {email, password})
    }
    catch(error){
        throw error;
    }
}